import styled from 'styled-components';

import Color from '../../styles/color';

export const Product = styled.div`
  .details {
    margin-top: 10px;

    > h3 {
      font-size: 16px;
      color: ${Color.neutral};
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
`;

export const FooterButtonServiceAcceptance = styled.div`
  background: ${Color.white};
  > p {
    font-size: 16px;
    color: ${Color.neutral90};
    padding-top: 10px;
    padding-bottom: 16px;
    line-height: 22px;
  }
`;
